const LEVEL_ERROR = "danger" as const;
const LEVEL_WARN = "warning" as const;
const LEVEL_INFO = "info" as const;
const LEVEL_SUCCESS = "success" as const;

export type MessageLevel =
  | typeof LEVEL_ERROR
  | typeof LEVEL_WARN
  | typeof LEVEL_INFO
  | typeof LEVEL_SUCCESS;

const LEVEL_WEIGHTS: Record<MessageLevel, number> = {
  [LEVEL_ERROR]: 0,
  [LEVEL_WARN]: 10,
  [LEVEL_INFO]: 20,
  [LEVEL_SUCCESS]: 30,
};

// Filter any message matching the following status codes.
// 401 result in auth logout so there is no case where we
// display a message to the user.
const MESSAGE_AUTH_CODES = [401] as const;

export {
  LEVEL_ERROR,
  LEVEL_INFO,
  LEVEL_SUCCESS,
  LEVEL_WARN,
  LEVEL_WEIGHTS,
  MESSAGE_AUTH_CODES,
};
